import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  inject,
  onBeforeMount,
  ref,
  computed,
  ComputedRef, PropType,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppTab',
  props: {
  color: {
    type: String as PropType<'black' | 'primary'>,
    default: 'black',
  },
},
  setup(__props) {

const onTabClick = inject<(index: number) => void>('onTabClick');
const currentActiveTabIndex = inject<ComputedRef<number>>('currentActiveTabIndex');
const onTabBeforeMount = inject<() => number>('onTabBeforeMount', () => 0);
const currentTabIndex = ref<number>(0);

const isActive = computed(() => currentActiveTabIndex?.value === currentTabIndex.value);



onBeforeMount(() => {
  currentTabIndex.value = onTabBeforeMount();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass([
      'app-tab',
      isActive.value ? 'app-tab--active' : '',
      `app-tab--${__props.color}`,
    ]),
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => _unref(onTabClick)(currentTabIndex.value), ["prevent"]))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})